import React, { ReactElement } from "react";

interface Props {
  condition: boolean;
  comment?: any;
}

export function If(props: React.PropsWithChildren<Props>): ReactElement | null {
  if (props.condition) {
    return <>{props.children}</>;
  }

  return null;
}
